import React from 'react';

import Drawer from '@mui/material/Drawer';

import { useTranslation } from "react-i18next";

const MapDrawer = (props) => {

  const [t] = useTranslation('common');

    let list = () => (
      <div
        style={{ width: "350px" }}
        role="presentation"
      //onClick={props.toggle}
      //onKeyDown={props.toggle}
      >
        <h2 className="pt-2 pb-2 text-center">{t('map.infopanel.vehicles')}</h2>
        <div className="overflow-y-scroll pt-1" style={{ maxHeight: "90vh" }}>
          {props.children}
        </div>

      </div>

    );

    return (
      <Drawer anchor={'right'} open={props.open} onClose={props.toggle}>
        {list('right')}
      </Drawer>
    )

}

export default MapDrawer;